export {};
//# sourceMappingURL=ConnectionProps.js.map